// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--townsquare/townsquare-onboarding-widget';

import { MessageFrontend as createMessageFrontendTownsquareTwcChatOnboarding } from '@post-office/browser--growth-starburst/townsquare-twc-chat-onboarding/placements/in-app-v2/townsquare-onboarding-widget';
import { MessageFrontend as createMessageFrontendTownsquareTwcConfluenceOnboarding } from '@post-office/browser--growth-starburst/townsquare-twc-confluence-onboarding/placements/in-app-v2/townsquare-onboarding-widget';
import { MessageFrontend as createMessageFrontendTownsquareTwcGettingStartedOnboarding } from '@post-office/browser--growth-starburst/townsquare-twc-getting-started-onboarding/placements/in-app-v2/townsquare-onboarding-widget';
import { MessageFrontend as createMessageFrontendTownsquareTwcGoalsOnboarding } from '@post-office/browser--growth-starburst/townsquare-twc-goals-onboarding/placements/in-app-v2/townsquare-onboarding-widget';
import { MessageFrontend as createMessageFrontendTownsquareTwcJiraOnboarding } from '@post-office/browser--growth-starburst/townsquare-twc-jira-onboarding/placements/in-app-v2/townsquare-onboarding-widget';
import { MessageFrontend as createMessageFrontendTownsquareTwcLoomOnboarding } from '@post-office/browser--growth-starburst/townsquare-twc-loom-onboarding/placements/in-app-v2/townsquare-onboarding-widget';
import { MessageFrontend as createMessageFrontendTownsquareTwcSearchOnboarding } from '@post-office/browser--growth-starburst/townsquare-twc-search-onboarding/placements/in-app-v2/townsquare-onboarding-widget';
import { MessageFrontend as createMessageFrontendTownsquareTwcStudioOnboarding } from '@post-office/browser--growth-starburst/townsquare-twc-studio-onboarding/placements/in-app-v2/townsquare-onboarding-widget';
import { MessageFrontend as createMessageFrontendTownsquareTwcTeamsOnboarding } from '@post-office/browser--growth-starburst/townsquare-twc-teams-onboarding/placements/in-app-v2/townsquare-onboarding-widget';

import { withI18n } from './i18n';

import {
	type PlacementRendererStage,
	type NoProps,
} from '@post-office/message-maker-browser/types';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendTownsquareTwcChatOnboarding({
		messageTemplateId: 'townsquare-twc-chat-onboarding',
	}),
	createMessageFrontendTownsquareTwcConfluenceOnboarding({
		messageTemplateId: 'townsquare-twc-confluence-onboarding',
	}),
	createMessageFrontendTownsquareTwcGettingStartedOnboarding({
		messageTemplateId: 'townsquare-twc-getting-started-onboarding',
	}),
	createMessageFrontendTownsquareTwcGoalsOnboarding({
		messageTemplateId: 'townsquare-twc-goals-onboarding',
	}),
	createMessageFrontendTownsquareTwcJiraOnboarding({
		messageTemplateId: 'townsquare-twc-jira-onboarding',
	}),
	createMessageFrontendTownsquareTwcLoomOnboarding({
		messageTemplateId: 'townsquare-twc-loom-onboarding',
	}),
	createMessageFrontendTownsquareTwcSearchOnboarding({
		messageTemplateId: 'townsquare-twc-search-onboarding',
	}),
	createMessageFrontendTownsquareTwcStudioOnboarding({
		messageTemplateId: 'townsquare-twc-studio-onboarding',
	}),
	createMessageFrontendTownsquareTwcTeamsOnboarding({
		messageTemplateId: 'townsquare-twc-teams-onboarding',
	}),
];

export const RawPlacement: PlacementRendererStage<NoProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<NoProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<NoProps> = RawPlacement;
